import LegalPageEditor from './LegalPageEditor'

const SECTIONS = [
    { id: 'definitions', label: '1. Definitions' },
    { id: 'eligibility', label: '2. Eligibility and Approval' },
    { id: 'relationship', label: '3. Affiliate Relationship' },
    { id: 'referral-codes', label: '4. Referral Codes' },
    { id: 'commission', label: '5. Commission Structure' },
    { id: 'payment', label: '6. Commission Payment' },
    { id: 'prohibited', label: '7. Prohibited Conduct' },
    { id: 'brand', label: '8. Brand and Intellectual Property' },
    { id: 'termination', label: '9. Termination' },
    { id: 'liability', label: '10. Limitation of Liability' },
    { id: 'general', label: '11. General & Contact' },
]

export default function AffiliateTermsCmsPage() {
    return (
        <LegalPageEditor
            page="affiliate-terms"
            liveUrl={`${import.meta.env.VITE_FRONTEND_URL || 'https://tendercentrix.com'}/affiliate-terms`}
            pageTitle="Affiliate Terms — Content Editor"
            pageDescription="Edit the hero and all 11 affiliate programme sections. Content is stored as HTML."
            sections={SECTIONS}
        />
    )
}
